export const buildQuery = (data: { [key: string]: any } | null) => {
  if (!data) return '';

  return Object.keys(data)
    .filter((key) => {
      const value = data[key];
      return value !== '' && value !== null && value !== undefined;
    })
    .map((key) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(data[key]));
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');
};
